(() => {
  if (window.aceInquiryContextInitialized) return;
  window.aceInquiryContextInitialized = true;
  const clean = (value, limit) => (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
  const safeSource = (value, productOnly = false) => {
    let url;
    try { url = new URL(clean(value, 1800), window.location.origin); } catch { return null; }
    if (!value || url.origin !== window.location.origin || /%(?:2f|5c)/i.test(url.pathname)) return null;
    if (url.hash) {
      let fragment;
      try { fragment = decodeURIComponent(url.hash.slice(1)); } catch { fragment = ''; }
      if (!/^[\p{L}\p{N}_-]{1,120}$/u.test(fragment)) url.hash = '';
    }
    const productPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/?#\\]+$/i.test(url.pathname);
    if (url.search && (!productPath || [...url.searchParams.keys()].length !== 1 || !/^\d{1,20}$/.test(url.searchParams.get('variant') || ''))) return null;
    const casePath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/delivery-cases?(?:-[^/?#\\]+)?$/i.test(url.pathname);
    return productPath || (!productOnly && casePath) ? url : null;
  };
  const fillInquiry = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-ace-inquiry-context]').forEach((context) => {
      if (context.dataset.ready === 'true' || context.dataset.posted === 'true') return;
      const form = context.closest('form');
      if (!form) return;
      const field = (selector) => context.querySelector(selector);
      const titleField = field('[data-ace-source-title]');
      const sourceField = field('[data-ace-source-url]');
      const nameField = field('[data-ace-inquiry-name]');
      const skuField = field('[data-ace-inquiry-sku]');
      const productField = field('[data-ace-inquiry-url]');
      const source = safeSource(sourceField.value || params.get('source_url') || params.get('product_url'));
      const title = clean(titleField.value || params.get('source_title') || params.get('product_name'), 300);
      if (!source || !title) return;
      titleField.value = title;
      sourceField.value = source.href;
      const product = safeSource(productField.value || params.get('product_url') || source.href, true);
      const name = clean(nameField.value || params.get('product_name') || (product ? title : ''), 300);
      if (product && name) {
        nameField.value = name;
        skuField.value = clean(skuField.value || params.get('product_sku'), 150) || skuField.dataset.emptyLabel;
        productField.value = product.href;
        context.querySelectorAll('[data-ace-product-field]').forEach((row) => { row.hidden = false; });
        const message = form.querySelector('[data-ace-inquiry-message]');
        if (message && !message.value.trim()) message.value = message.dataset.aceInquiryMessage;
      }
      const action = new URL(form.action, window.location.origin);
      if (action.origin === window.location.origin) {
        action.searchParams.set('source_url', source.pathname + source.search + source.hash);
        action.searchParams.set('source_title', title);
        if (product && name) {
          action.searchParams.set('product_url', product.pathname + product.search + product.hash);
          action.searchParams.set('product_name', name);
          action.searchParams.set('product_sku', skuField.value);
        }
        form.action = action.href;
      }
      context.dataset.ready = 'true';
      context.hidden = false;
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, window.location.origin); } catch { return; }
    if (destination.origin !== window.location.origin || !/\/pages\/(?:contact|space-consultation)$/.test(destination.pathname)) return;
    const localProduct = link.closest?.('product-info');
    const pageProduct = document.querySelector?.('main product-info[data-update-url="true"]');
    const productInfo = localProduct || pageProduct;
    const productUrl = safeSource(productInfo?.dataset?.url, true);
    let source = safeSource(destination.searchParams.get('source_url'));
    let current = safeSource(window.location.pathname + window.location.hash);
    const productMatches = productUrl && (!source || source.pathname === productUrl.pathname);
    if (productMatches && (localProduct || current?.pathname === productUrl.pathname || /\/products_preview$/.test(window.location.pathname))) {
      current = safeSource(productUrl.pathname + (current?.pathname === productUrl.pathname || /\/products_preview$/.test(window.location.pathname) ? window.location.hash : ''));
    }
    if (!source) {
      if (!link.closest?.('main, footer')) return;
      source = current;
      const title = clean(document.querySelector?.('main h1')?.textContent, 300);
      if (!source || !title) return;
      destination.searchParams.set('source_title', title);
    }
    if (!current || source.pathname !== current.pathname) return;
    destination.searchParams.set('source_url', current.pathname + current.hash);
    if (safeSource(current.href, true)) {
      destination.searchParams.set('product_url', current.pathname);
      destination.searchParams.set('product_name', destination.searchParams.get('product_name') || destination.searchParams.get('source_title') || '');
      const selected = productMatches ? productInfo?.querySelector?.('variant-selects [data-selected-variant]') : null;
      if (selected) {
        try {
          const variant = JSON.parse(selected.textContent);
          destination.searchParams.set('product_sku', clean(variant?.sku, 150));
          const variantId = String(variant?.id || '');
          if (/^\d{1,20}$/.test(variantId)) {
            const selectedPath = current.pathname + '?variant=' + variantId;
            destination.searchParams.set('product_url', selectedPath);
            destination.searchParams.set('source_url', selectedPath + current.hash);
          }
        } catch {}
      }
    }
    link.href = destination.href;
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillInquiry, { once: true });
  else fillInquiry();
  document.addEventListener('shopify:section:load', fillInquiry);
})();

